module.exports = __webpack_public_path__ + "../resources/images/compactNotSelected-b9fe4dfbb99f9f7b731b4bad7385e1b4.svg";